export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7062.73be9a05.jpg";